import { type PipeTransform, Pipe, inject } from '@angular/core';
import { DomSanitizer, type SafeHtml } from '@angular/platform-browser';

@Pipe({
    name: 'spSafeHtml',
    standalone: true,
})
export class SpSafeHtmlPipe implements PipeTransform {
    private readonly sanitized = inject(DomSanitizer);

    public transform(value: string): SafeHtml {
        if (!value) {
            return '';
        }

        return this.sanitized.bypassSecurityTrustHtml(value);
    }
}
